/**
 * Feature flags for gradual rollout and testing.
 * Set via environment variables (REACT_APP_*).
 */

/**
 * Enable Stripe payment flow.
 * When false, the "Pay now" button and payment UI are hidden.
 * Set REACT_APP_ENABLE_STRIPE_PAYMENTS=true to enable.
 */
export const isStripePaymentsEnabled = (): boolean => {
  return process.env.REACT_APP_ENABLE_STRIPE_PAYMENTS === 'true';
};
